// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL;
const AUTH_BASE_URL = process.env.REACT_APP_AUTH_URL;
const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_URL || (process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace(/\/api$/, '/public') : '');
const OMI_BASE_URL = process.env.REACT_APP_OMI_URL;

export { API_BASE_URL, AUTH_BASE_URL, OMI_BASE_URL, PUBLIC_BASE_URL };
